import {AbstractAdminEntityService} from "./AbstractAdminEntityService";
import {User, ListUsersResponse, UserAuditRequest, UserAuditResponse, EventView} from "../../../generated/protocol";
import {AdminEntityService} from "./AdminEntityService";
import {injectable} from "inversify";
import {PlayerRevenueResponse} from "../../../generated/protocol";
import * as moment from "moment";

export const USER_AUDIT_SERVICE_NAME = "userAuditService";

export interface UserAuditService extends AdminEntityService<EventView> {
    list(listRequest: UserAuditRequest): Promise<UserAuditResponse>;

    getRevenueReport(userId: Number, from: Number, to: Number): Promise<PlayerRevenueResponse>;
}

@injectable()
export class UserAuditServiceImpl extends AbstractAdminEntityService<EventView, UserAuditResponse> {

    constructor() {
        super("/user/audit");
    }

    list(listRequest: UserAuditRequest): Promise<UserAuditResponse> {
        if (listRequest.from == undefined) {
            // force 1 month back as from date if it isn't set, and set to ms
            let fromDate = moment().subtract(1, 'months').unix() * 1000;
            listRequest.from = fromDate;
        }
        return this.http.doPost(this.entityPath + "/list", listRequest);
    }

    save(entity: EventView): Promise<EventView> {
        throw "Unsupported Operation";
    }

    getEntity(id: string): Promise<EventView> {
        throw "Unsupported Operation";
    }

    remove(id: string): Promise<{}> {
        throw "Unsupported Operation";
    }

    getRevenueReport(userId: number, from: number, to: number): Promise<PlayerRevenueResponse> {
        return this.http.doGet(this.entityPath + "/revenue/" + userId + "?from=" + from + "&to=" + to);
    }
}



// WEBPACK FOOTER //
// ./src/app/service/admin/UserAuditService.ts